import { Howl } from 'howler'
import { signal } from 'services/SignalsService'
import { config } from 'settings/custom/audiosprite'
import { getRandomInt } from 'utils/Random'

export default class SoundCore {
  constructor() {
    this.howl = null
    this.ids = {}
    this.names = {}
    this.edit = false
  }

  init() {
    this.howl = new Howl(config)
    this.howl.on('end', this.onEnd.bind(this))
    this.howl.on('fade', this.onFade.bind(this))
    this.howl.once('load', this.subscribe.bind(this))
  }

  subscribe() {
    signal.dispatch('SOUND:load', game.models.FreespinModel.get().all > 0 && game.models.FreespinModel.get().left !== game.models.FreespinModel.get().all ? 'freespins' : 'regular')
  }

  play({ name, loop, fade, volume, random, ducking }) {
    if(!this.edit){
      if (random) {
        name = name.replace('{n}', `0${getRandomInt(random[0], random[1])}`)
      }

      if (ducking) {
        ducking.all ? duckAll(ducking.all) : duckSome(ducking)
      }

      const id = this.howl.play(name)

      this.howl.fade(0, volume, fade, id)
      this.howl.loop(loop, id)
      this.names[name] = id
      this.ids[id] = {
        name,
        loop,
        volume,
        ducking,
        playing: true,
      }
    }

    function duckAll({ volume, fade }) {
      Object.keys(this.ids).forEach((trackId) => {
        this.ids[trackId].realVolume = this.ids[trackId].volume
        this.howl.fade(0, volume, fade, trackId)
      })
    }

    function duckSome(obj) {
      Object.keys(obj).forEach((name) => {
        const trackId = this.names[name]
        this.ids[trackId].realVolume = this.ids[trackId].volume
        this.howl.fade(0, obj[name].volume, obj[name].fade, trackId)
      })
    }
  }

  stop({ name, fade }) {
    const id = this.names[name]
    if (id && !this.edit) {
      this.ids[id].fade = 'stop'
      this.howl.fade(this.ids[id].volume, 0, fade, id)
    }
  }

  pause({ name, fade }) {
    const id = this.names[name]
    if (id && !this.edit) {
      this.ids[id].fade = 'pause'
      this.howl.fade(this.ids[id].volume, 0, fade, id)
    }
  }

  resume({ name, fade }) {
    const id = this.names[name]
    if (id && !this.edit) {
      this.howl.play(id)
      this.howl.fade(0, this.ids[id].volume, fade, id)
    }
  }

  resumeAll() {
    Object.keys(this.ids).forEach((id) => {
      if(this.ids[id].playing){
        this.howl.play(+id)
      }
    })
  }

  mute(enabled) {
    this.howl.mute(!enabled)
  }

  onEnd(id) {
    !this.ids[id].loop && this._stop.call(this, id)
  }

  onFade(id) {
    const command = this.ids[id].fade
    if(this.ids[id].fade){
      command == 'stop' ? this._stop(id) : this._pause(id)
    }
    delete this.ids[id].fade
  }

  _stop(id) {
    this.howl.stop(id)
    this.ids[id].playing = false

    if (this.ids[id].ducking) {
      this.ids[id].ducking.all ? revertAll(this.ids[id].ducking.all) : revertSome(this.ids[id].ducking)
    }

    function revertAll({ fade }) {
      Object.keys(this.ids).forEach((trackId) => {
        this.howl.fade(this.ids[trackId].realVolume, 0, fade, trackId)
        delete this.ids[trackId].realVolume
      })
    }

    function revertSome(obj) {
      Object.keys(obj).forEach((name) => {
        const trackId = this.names[name]
        this.howl.fade(this.ids[trackId].realVolume, 0, obj[name].fade, trackId)
        delete this.ids[trackId].realVolume
      })
    }
  }

  _pause(id) {
    this.howl.pause(id)
  }

  setEdit(value){
    this.edit = value
    value ? this._pause() : this.resumeAll()
  }
}
